function customBannersCategory() {
    var pathname = window.location.pathname;
    var stranaIndex = pathname.indexOf('strana');
    if (stranaIndex > -1) {
        pathname = pathname.substring(0, stranaIndex);
    }
    var foundMatch = false;
    var products = $('#products .product');
    var productsCount = products.length;
    var useRescueBanner = false; // Přidáno pro zjištění, zda se má použít "záchranný banner"
    var rescueBannerData = null;

    customCategoryBanners.forEach(function (categoryItem) {
        if (categoryItem.Category['zachrany-banner'] === 'ano') {
            rescueBannerData = categoryItem.Category; // Uložení "záchranného banneru" pro pozdější použití
        }
    });

    customCategoryBanners.forEach(function (categoryItem) {
        var item = categoryItem.Category;

        if (!foundMatch && $('.type-category').length) {
            // Tato podmínka se vyhodnotí, pokud se nenajde shoda a stránka je typu .type-category
            useRescueBanner = true; // Nastavíme příznak, že se má použít "záchranný banner"
        }

        if (typeof item.categoryBanners !== 'undefined') {

            if ($('.type-category').length) {
                setTimeout(function () {
                    $('header#header+.categoryTopHeader h1').html($('.category-top .category-title').html());
                }, 350);
            }

            if (item.categoryUrl === pathname) {
                foundMatch = true;
                item.categoryBanners.forEach(function (banner, bannerIndex) {
                    var insertBanner = function (bannerData, position) {
                        var bannerId = 'banner-' + bannerIndex + '-' + position;
                        if ($('#' + bannerId).length === 0) {
                            var bannerHtml = $('<div class="product-banner product ' + bannerData.class + '" id="' + bannerId + '" style="height:' + $('.products .product').first().outerHeight() + 'px;"><div class="inner" style="background-image:url(' + bannerData.obrazek + ');background-position:center center;"><div class="title">' + bannerData.nadpis + '</div><p>'+bannerData.popis+'</p><a href="' + bannerData.linkUrl + '" class="buttonRelative"></a><a href="' + bannerData.linkUrl + '" class="btn">' + bannerData.linkText + '</a></div></div>');
                            var targetPosition = position < productsCount ? position : productsCount - 1;
                            if (products.eq(targetPosition).length) {
                                products.eq(targetPosition).after(bannerHtml);
                            } else {
                                $('#products').append(bannerHtml);
                            }
                        }
                    };

                    if (banner.bannerFirst && banner.bannerFirst.length > 0) {
                        insertBanner(banner.bannerFirst[0], 2);
                    }

                    if (banner.bannerSecond && banner.bannerSecond.length > 0) {
                        insertBanner(banner.bannerSecond[0], 6);
                    }
                });
            }

        } else {
            if ($('.type-category').length && rescueBannerData) {
                rescueBannerData.categoryBanners.forEach(function (banner, bannerIndex) {
                    var insertBanner = function (bannerData, position) {
                        var bannerId = 'banner-' + bannerIndex + '-' + position;
                        if ($('#' + bannerId).length === 0) {
                            var bannerHtml = $('<div class="product-banner product ' + bannerData.class + '" id="' + bannerId + '" style="height:' + $('.products .product').first().outerHeight() + 'px;"><div class="inner" style="background-image:url(' + bannerData.obrazek + ');background-position:center center;"><div class="title">' + bannerData.nadpis + '</div><p>'+bannerData.popis+'</p><a href="' + bannerData.linkUrl + '" class="buttonRelative"></a><a href="' + bannerData.linkUrl + '" class="btn">' + bannerData.linkText + '</a></div></div>');
                            var targetPosition = position < productsCount ? position : productsCount - 1;
                            if (products.eq(targetPosition).length) {
                                products.eq(targetPosition).after(bannerHtml);
                            } else {
                                $('#products').append(bannerHtml);
                            }
                        }
                    };

                    if (banner.bannerFirst && banner.bannerFirst.length > 0) {
                        insertBanner(banner.bannerFirst[0], 2);
                    }

                    if (banner.bannerSecond && banner.bannerSecond.length > 0) {
                        insertBanner(banner.bannerSecond[0], 6);
                    }
                });
            }
        }
    });

    if (!foundMatch && useRescueBanner && rescueBannerData) {
        rescueBannerData.categoryBanners.forEach(function (banner, bannerIndex) {
            var insertBanner = function (bannerData, position) {
                var bannerId = 'banner-' + bannerIndex + '-' + position;
                if ($('#' + bannerId).length === 0) {
                    var bannerHtml = $('<div class="product-banner product ' + bannerData.class + '" id="' + bannerId + '" style="height:' + $('.products .product').first().outerHeight() + 'px;"><div class="inner" style="background-image:url(' + bannerData.obrazek + ');background-position:center center;"><div class="title">' + bannerData.nadpis + '</div><p>'+bannerData.popis+'</p><a href="' + bannerData.linkUrl + '" class="buttonRelative"></a><a href="' + bannerData.linkUrl + '" class="btn">' + bannerData.linkText + '</a></div></div>');
                    var targetPosition = position < productsCount ? position : productsCount - 1;
                    if (products.eq(targetPosition).length) {
                        products.eq(targetPosition).after(bannerHtml);
                    } else {
                        $('#products').append(bannerHtml);
                    }
                }
            };

            if (banner.bannerFirst && banner.bannerFirst.length > 0) {
                insertBanner(banner.bannerFirst[0], 2);
            }

            if (banner.bannerSecond && banner.bannerSecond.length > 0) {
                insertBanner(banner.bannerSecond[0], 6);
            }
        });
    }

    if ($('.products .product:not(.product-banner)').length < 4) {
        $('.product-banner#banner-0-6').remove();
    }
}
